// extracted by mini-css-extract-plugin
export default {"otpGroup":"OtpInput_otpGroup__4evhn","otpInput":"OtpInput_otpInput__Ehdof"};